import { render } from "./teaStudioManager.vue?vue&type=template&id=177ff3b4&scoped=true"
import script from "./teaStudioManager.vue?vue&type=script&lang=js"
export * from "./teaStudioManager.vue?vue&type=script&lang=js"

import "./teaStudioManager.vue?vue&type=style&index=0&id=177ff3b4&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177ff3b4"]])

export default __exports__